export const userStatuses = [
  { value: 'active', label: 'активен', color: '' },
  { value: 'blocked', label: 'заблокирован', color: '' },
  { value: 'unconfirmed', label: 'не активен', color: '' },
];

export function getUserStatus(user) {
  if (!user.accountConfirmed) {
    return userStatuses[2];
  }

  if (user.accountBlocked) {
    return userStatuses[1];
  }

  return userStatuses[0];
}
